/**
 * Дата коротким словом месяца: «05 сен 26».
 *
 * <p><b>Своя таблица месяцев, а не `Intl`.</b> Короткое имя в `ru-RU`
 * зависит от сборки ICU («сент.» против «сен»), и экран показывал бы разное
 * в браузере и в тестах — то есть тест на слово стерёг бы не то, что видит
 * человек.
 *
 * <p><b>Общая, а не по копии на экран.</b> Копий было три — прайсы, реестр
 * возвратов и журнал пересчётов, — и они уже разошлись: в одной стоял
 * родительный падеж («05 мая»), в двух именительный («05 май»), то есть
 * на соседних экранах одна и та же дата в мае писалась по-разному, причём
 * в одном месте с ошибкой. Форма родительная: так дату и читают вслух.
 *
 * <p>Момент разбирается `new Date` намеренно: сюда приходят метки времени
 * с часовым поясом (`started_at`, `created_at`). Дата без времени
 * (`2026-08-30`) так разбираться не должна — конструктор берёт полночь UTC,
 * и западнее Гринвича день уезжает на вчерашний.
 */
export const MONTHS = ['янв', 'фев', 'мар', 'апр', 'мая', 'июн',
  'июл', 'авг', 'сен', 'окт', 'ноя', 'дек'];

export function shortDate(iso: string): string {
  const at = new Date(iso);
  const day = String(at.getDate()).padStart(2, '0');
  const year = String(at.getFullYear()).slice(-2);
  return `${day} ${MONTHS[at.getMonth()]} ${year}`;
}
